import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { fonts, responsiveText, spacing } = theme;

const showOnTwoLines = css`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const outerCard = css`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${spacing.xs}px;
`;

export const link = css`
  text-decoration: none;
`;

export const topInnerCard = css`
  position: relative;
  margin: 0;
  overflow: hidden;

  img {
    display: block;
    position: relative;
    object-fit: cover;
    object-position: 50% 0;
    border-radius: inherit;
    width: 100%;
    aspect-ratio: 1;
  }
`;

const IMAGE_LABEL_EDGE_GAP_PX = 12;
const IMAGE_LABEL_RADIUS = 16;
const MOBILE_EDGE_GAP = 8;

const mobileEdgeGap = css`
  margin-left: ${MOBILE_EDGE_GAP}px;
  margin-right: ${MOBILE_EDGE_GAP}px;
  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      margin-left: 0;
      margin-right: 0;
    `,
  )}
`;

export const imageLabels = (deliveryLabelOnly: boolean) => css`
  position: absolute;
  left: ${IMAGE_LABEL_EDGE_GAP_PX}px;
  top: ${IMAGE_LABEL_EDGE_GAP_PX}px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  column-gap: 10px;
  ${responsiveText.BODY.SM};
  white-space: nowrap;

  ${deliveryLabelOnly && '  justify-content: flex-end;'}
`;

export const primaryLabel = (type: 'new' | 'offer' | 'stock') => css`
  flex-shrink: 0;
  padding: ${spacing.base}px ${spacing.xs}px;
  border-radius: ${IMAGE_LABEL_RADIUS}px;

  ${type === 'new' &&
  ` background-color: var(--brand-bluple-base);
    color: var(--neutral-white-base);`}

  ${type === 'offer' &&
  ` background-color: var(--functional-red-base);
    color: var(--neutral-white-base);`}

  ${type === 'stock' &&
  ` background-color: var(--neutral-white-base);
    color: var(--brand-bluple-base);`}
`;

export const deliveryLabel = css`
  padding: ${spacing.xs}px 0;
  border-top: 1px solid var(--brand-purple-10);
  color: var(--neutral-black-base);
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  ${responsiveText.BODY.SM};
  ${mobileEdgeGap};

  span {
    margin-right: ${spacing.base}px;
    align-self: flex-start;

    ${mediaQuery(
      { min: minBreakpoints.M },
      css`
        align-self: center;
      `,
    )};
  }
`;

const FAVOURITE_BUTTON_HEIGHT = 44;

export const favouriteButtonWrapper = css`
  position: absolute;
  top: 0;
  right: ${spacing.xs}px;

  margin-top: calc(100% - ${spacing.xs}px - ${FAVOURITE_BUTTON_HEIGHT}px);
  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      right: ${spacing.md}px;
      margin-top: calc(100% - ${spacing.md}px - ${FAVOURITE_BUTTON_HEIGHT}px);
    `,
  )};
`;

export const soldBy = css`
  margin: ${spacing.xs}px 0;
  color: var(--brand-bluple-base);
  ${responsiveText.BODY.XS};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  ${mobileEdgeGap};
  ${showOnTwoLines};
  text-transform: uppercase;
`;

export const title = css`
  margin: 0;
  color: var(--neutral-black-base);
  ${responsiveText.BODY.MD};
  ${mobileEdgeGap};
  font-weight: ${fonts.PRIMARY_REGULAR.weight};
  ${showOnTwoLines};
`;

export const bottomInnerCard = css`
  ${responsiveText.BODY.SM};
  ${mobileEdgeGap};
`;

export const currentPrice = css`
  display: inline-block;
  margin: 0;
`;

export const previousPrice = css`
  display: inline-block;
  margin: 0 0 0 ${spacing.xs}px;
`;

export const deliveryEvent = css`
  display: block;
  margin: 0;

  strong {
    display: inline-block;
    padding: ${spacing.base}px ${spacing.xs}px;
    background-color: var(--brand-purple-30);
    color: var(--brand-bluple-base);
    ${responsiveText.BODY.SM};
    font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  }
`;
